export default "https://cdn.questicon.mathletics.com/assets/images/concept-refresh-btn-b9cbbabd1a92d2106ce699d663738aba.png";